import React from 'react'
import { Link, useMatches } from 'react-router-dom'
import { Item, Toolbar } from 'devextreme-react/toolbar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faWrench } from '@fortawesome/free-solid-svg-icons'
import classNames from 'classnames'
import styles from './BreadCrumbs.module.scss'
import { Crumb, CrumbResult, OptionalLoaderGeneric, TypedMatch } from '@/types'
import { Button } from 'devextreme-react'
import notify from 'devextreme/ui/notify'
import { hasCrumb } from '@/routes/utils'

export const createDescriptor = {
  label: 'Crea',
  icon: faWrench,
}

// Type safe breadcrumb content component
const BreadcrumbContent = ({ crumbs }: { crumbs: Array<CrumbResult & { path: string }> }) => (
  <nav className={styles.breadcrumbsWrapper} aria-label="Breadcrumb">
    <Link to="/" className={styles.breadcrumbItem}>
      {/*<FontAwesomeIcon icon={faHome} className={styles.homeIcon} aria-label="Home" />*/}
      <span className={styles.homeTitle}>Qs Web Admin</span>
    </Link>

    {crumbs.map((crumb, index) => (
      <React.Fragment key={crumb.path}>
        <FontAwesomeIcon icon={faChevronRight} className={styles.separator} aria-hidden="true" />
        <Link
          to={crumb.path}
          className={classNames(styles.breadcrumbItem, {
            [styles.active]: index === crumbs.length - 1,
          })}
          aria-current={index === crumbs.length - 1 ? 'page' : undefined}
        >
          {crumb.icon && <FontAwesomeIcon icon={crumb.icon} className={styles.itemIcon} aria-hidden="true" />}
          <span className={index === crumbs.length - 1 ? styles.boldBreadcrumbText : styles.breadcrumbText}>
            {crumb.label}
          </span>
        </Link>
      </React.Fragment>
    ))}
    {crumbs.length > 0 && (
      <Button
        type="default"
        stylingMode="text"
        hint="Copy link"
        icon="fas fa-link"
        onClick={async () => {
          try {
            await navigator.clipboard.writeText(
              `${window.location.origin}${crumbs[crumbs.length - 1].path}${window.location.search}`,
            )
            notify('Link copiato con successo', 'success', 2000)
          } catch (err) {
            console.log('Failed to copy link to clipboard', err)
            notify('Failed to copy link to clipboard', 'error', 2000)
          }
        }}
      ></Button>
    )}
  </nav>
)

export const BreadCrumbs = () => {
  // Get all matches from the router with proper typing for void/optional loader functions
  const matches = useMatches() as Array<TypedMatch<void>>

  // Filter and map the matches to breadcrumb items
  const crumbs = matches
    .filter((element) => hasCrumb(element))
    .map((match) => {
      try {
        // Since we've filtered, we know crumb exists and can safely call it
        const crumbData = match.handle.crumb(match)
        return {
          label: crumbData.label,
          icon: crumbData.icon,
          path: match.pathname,
        }
      } catch {
        // A crumb can throw when its route loader errored (es. 404): in quel caso match.data è
        // undefined. La saltiamo così la barra dei breadcrumb non fa crashare l'intero layout.
        return null
      }
    })
    .filter((crumb): crumb is NonNullable<typeof crumb> => crumb !== null)
  console.log('crumbs', crumbs)
  return (
    <div className={styles.breadcrumbsContainer}>
      <Toolbar>
        <Item location="before" render={() => <BreadcrumbContent crumbs={crumbs} />} />
      </Toolbar>
    </div>
  )
}

export default BreadCrumbs
